import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const ADS_ID = "AW-18534467571";
let loaded = false;

const load = () => {
  if (loaded) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  const s = Object.assign(document.createElement("script"), { async: true, src: `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}` });
  document.head.appendChild(s);
};

// Google Ads tag for public marketing pages only; signed-in people never load it.
export const useGoogleTag = (path) => {
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading || user) return;
    load();
    window.gtag("config", ADS_ID, { page_path: path, page_location: `${window.location.origin}${path}${window.location.search}` });
  }, [path, loading, user]);
};
